export default {
    TOKEN: 'trks-bo-token',
    ENV: 'trks-bo-env',
}
